module.exports = __webpack_public_path__ + "img/logos/salesforce-eb3673a658fb731977cec72450e2ac17.svg";